export const getInitials = name =>
  name
    .split('')
    .filter(letter => {
      const unicod = letter.charCodeAt();

      return 64 < unicod && 91 > unicod;
    })
    .join('') || name;
